module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@2x-b9e67ca7c159a6dc0ad94a5db71d252e.png";